import React, { Fragment, useEffect } from 'react';
import { Grid, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SnackBar } from 'src/components/SnackBar';
import { Helmet } from 'react-helmet-async';
import ConfigurationSection from './ConfigurationSection';

const Configurations = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (Object.keys(user).length === 0) {
      navigate('/');
    }
  }, [navigate]);

  return (
    <Fragment>
      <Helmet>
        <title>Configurations</title>
      </Helmet>
      <Container maxWidth="xl">
        <Grid
          container
          direction="row"
          justifyContent="start"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <ConfigurationSection />
          </Grid>
        </Grid>
      </Container>
    </Fragment>
  );
};

export default Configurations;
